export interface IProductSelosProps {
  ultraDesconto?: boolean;
  descontoProgressivo?: boolean;
  possuiGenerico?: boolean;
  bloqueadoVendaSite?: boolean;
  freteGratis?: boolean;
  possuiBrinde?: boolean;
  ultraCompare?: boolean;
  importado?: string;
  ultraPremio?: boolean;
  seloLivre?: boolean;
  cliqueRetire?: boolean;
}

export interface ICardsProps {
  id: string;
  name: string;
  url: string;
  urlExpanded: string;
  urlExpandedFull: string;
  urlExpandedMobile: string;
}

export const cards = [
  // {
  //   id: 'freteGratis',
  //   name: 'FreteGratis',
  //   url: '/images/card-icons/frete-gratis.svg',
  //   urlExpanded: '/images/card-icons/frete-gratis-expanded.svg',
  //   urlExpandedMobile: '/images/card-icons/frete-gratis-expanded-mobile.svg',
  // },
  {
    id: 'ultraDesconto',
    name: 'UltraDesconto',
    url: '',
    urlExpanded: '',
    urlExpandedFull: '',
    urlExpandedMobile: '',
  },
  {
    id: 'descontoProgressivo',
    name: 'DescontoProgressivo',
    url: '/images/card-icons/desconto-progressivo.svg',
    urlExpanded: '/images/card-icons/desconto-progressivo-expanded.svg',
    urlExpandedMobile:
      '/images/card-icons/desconto-progressivo-expanded-mobile.svg',
  },
  {
    id: 'possuiGenerico',
    name: 'PossuiGenerico',
    url: '/images/card-icons/possui-generico.svg',
    urlExpanded: '/images/card-icons/possui-generico-expanded.svg',
    urlExpandedMobile: '/images/card-icons/possui-generico-expanded-mobile.svg',
  },
  {
    id: 'bloqueadoVendaSite',
    name: 'BloqueadoVendaSite',
    url: '/images/card-icons/bloqueado-venda-site.svg',
    urlExpanded: '/images/card-icons/bloqueado-venda-site-expanded.svg',
    urlExpandedMobile:
      '/images/card-icons/bloqueado-venda-site-expanded-mobile.svg',
  },
  {
    id: 'possuiBrinde',
    name: 'PossuiBrinde',
    url: '/images/card-icons/ganhe-brinde.svg',
    urlExpanded: '/images/card-icons/ganhe-brinde-expanded.svg',
    urlExpandedMobile: '/images/card-icons/ganhe-brinde-expanded-mobile.svg',
  },
  {
    id: 'ultraCompare',
    name: 'UltraCompare',
    url: '/images/card-icons/ultracompare.svg',
    urlExpanded: '/images/card-icons/ultracompare-expanded.svg',
    urlExpandedMobile: '/images/card-icons/ultracompare-expanded-mobile.svg',
  },
  {
    id: 'importadoUSA',
    name: 'Importado USA',
    url: '/images/card-icons/importado-estados-unidos.svg',
    urlExpanded: '/images/card-icons/importado-estados-unidos-expanded.svg',
    urlExpandedMobile:
      '/images/card-icons/importado-estados-unidos-expanded-mobile.svg',
  },
  {
    id: 'importadoEGY',
    name: 'Importado EGY',
    url: '/images/card-icons/importado-egito.svg',
    urlExpanded: '/images/card-icons/importado-egito-expanded.svg',
    urlExpandedMobile: '/images/card-icons/importado-egito-expanded-mobile.svg',
  },
  {
    id: 'importadoEUR',
    name: 'Importado EUR',
    url: '/images/card-icons/importado-uniao-europeia.svg',
    urlExpanded: '/images/card-icons/importado-uniao-europeia-expanded.svg',
    urlExpandedMobile:
      '/images/card-icons/importado-uniao-europeia-expanded-mobile.svg',
  },
  // {
  //   id: 'ultraPremio',
  //   name: 'UltraPremio',
  //   url: '/images/card-icons/ultrapremio.svg',
  //   urlExpanded: '/images/card-icons/ultrapremio-expanded.svg',
  //   urlExpandedMobile: '/images/card-icons/ultrapremio-expanded-mobile.svg',
  // },
  {
    id: 'seloLivre',
    name: 'SeloLivre',
    url: '',
    urlExpanded: '',
    urlExpandedMobile: '',
  },
  {
    id: 'cliqueRetire',
    name: 'Clique e Retire',
    url: '/images/card-icons/clique-retire.svg',
    urlExpanded: '/images/card-icons/clique-retire-expanded.svg',
    urlExpandedMobile: '/images/card-icons/clique-retire-expanded-mobile.svg',
  },
];

export const cardsPrimary = {
  // ultraDesconto: false,
  descontoProgressivo: false,
  // possuiGenerico: false,
  // bloqueadoVendaSite: false,
};

export const cardsSecondary = {
  possuiGenerico: false,
  bloqueadoVendaSite: false,

  ultraCompare: false,
  importado: '',
  ultraPremio: false,
  seloLivre: false,
  cliqueRetire: false,
};
